// extracted by mini-css-extract-plugin
export default {"box":"box-component_box__Vus96","mobileBox":"box-component_mobileBox__z57e3","desktopBox":"box-component_desktopBox__W7ItF"};